import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

function NationwideRollouts() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/nationwide_rollouts_collage.jpg)' }}
        ></div>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Nationwide <span className="text-gold">Roll Outs</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Coordinated multi-location construction and rollout services across the country
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              Managing multi-location construction projects requires specialized expertise, precise coordination, and unwavering consistency. Williams Diversified excels at nationwide rollouts for retail chains, restaurant brands, and corporations expanding across multiple markets.
            </p>
            <p>
              We serve as your single-source partner, managing everything from initial site surveys to final punch lists. Our nationwide rollout services ensure brand consistency, quality control, and on-time delivery across all locations—whether you're opening 5 locations or 50.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Approach</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Centralized project management</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Standardized construction processes</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Brand consistency across all locations</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Simultaneous multi-site coordination</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Budget and schedule optimization</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Comprehensive quality control</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Expand Your <span className="text-gold">Brand Nationwide</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default NationwideRollouts;